import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-line-icon',
  templateUrl: './design-line.component.html'
})
export class DesignLineComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
